export const SITE_VARIABLES = {
    COLORS: {
        DARK: '#999999',
        LIGHT: '#E5E5E5',
        LINK: '#9D2236',
        LIGHTWHITE: '#f9f9f9',
        GRAY: '#E5E5E5',
        MEDIUMGRAY: '#CCCCCC',
        DARKGRAY: '#999999',
        WHITE: '#f7f7f7',
        FsBlueDark: '#073759',
        FsBlueLight: '#5a94c1',
    },
    TEXT_FONT_FAMILY: {
        DEFAULT: '"Montserrat", Arial, sans-serif',
        TITLE: '"Roboto", Arial, sans-serif',
    },
    FONT_SIZE: {
        H1: {
            fontSize: '1.2rem',
            '@media (min-width: 1024px)': {
                fontSize: '1.6rem',
            },
        },
        H3: {
            fontSize: '1rem',
        },
    },
    CSS_SELECTORS: {
        HOVER: '&:hover',
        AFTER: '&::after',
        BEFORE: '&::before',
    },
    BREAKPOINTS: [480, 768, 1024],
}

export const mq = SITE_VARIABLES.BREAKPOINTS.map((bp) => `@media (min-width: ${bp}px)`)
